import { forwardRef, type Ref } from "react";

import { type SvgExtendedProps } from "./types";

function SvgWarning(
  {
    strokeColor = "#0C1C43",
    gradientStartColor = "#FFE3C3",
    gradientEndColor = "#F6F3F1",
    ...props
  }: SvgExtendedProps,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} width={176} height={120} viewBox="0 0 176 120" fill="none" {...props}>
      <path
        d="M43.2729 76.2457L75.2046 25.0685C81.085 15.6438 94.915 15.6438 100.795 25.0685L132.727 76.2457C138.925 86.1797 131.716 99 119.932 99H56.0684C44.2839 99 37.0747 86.1797 43.2729 76.2457Z"
        stroke="url(#paint0_linear_15471_32178)"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path
        d="M88.0003 47.1047V65.4381M88.0003 78.0422V77.9964M89.1462 78.0422C89.1462 78.6751 88.6332 79.1881 88.0003 79.1881C87.3675 79.1881 86.8545 78.6751 86.8545 78.0422C86.8545 77.4094 87.3675 76.8964 88.0003 76.8964C88.6332 76.8964 89.1462 77.4094 89.1462 78.0422Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15471_32178"
          x1="88"
          y1="18"
          x2="88"
          y2="99"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor={gradientStartColor} />
          <stop offset="1" stopColor={gradientEndColor} />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
